import React from 'react'

import { Box, Typography } from '@mui/material'


export default function airConditionColumn() {

	return {
		name: 'airCondition',
		label: 'A/C',
		options: {
			customBodyRowRenderLite: value => <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<Typography>{value ? 'Yes' : value !== null ? 'No' : 'Any'}</Typography>
			</Box>,
		},
	}
}